export default "__VITE_ASSET__D$gbdJHI__"